export default "/assets/ab641d21f3da0ce7.svg"